import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next"

import { ALLOWED_INTERFACE_LANGUAGES, BUILD, DEFAULT_LANGUAGE, LS_LNG_INTERFACE, PUBLIC_URL } from "./config";

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v4',

    showSupportNotice: false,
    fallbackLng: DEFAULT_LANGUAGE,
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${PUBLIC_URL}i18n/{{lng}}.json?${BUILD}`,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LS_LNG_INTERFACE,
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      caches: ["localStorage"],
      checkWhitelist: true,
      checkForSimilarInWhitelist: false,
    },
    supportedLngs: ALLOWED_INTERFACE_LANGUAGES,
  });

export const fetchLanguageData = (lng = 'en') => fetch(`${PUBLIC_URL}i18n/${lng}.json?${BUILD}`).then(r => r.json());

export default i18n;
